import { DatePicker } from "@mui/x-date-pickers";
import { normalizeDialogDate } from "./dialogDate";

export default function DialogDatePicker({ value, onChange, slotProps, ...props }) {
  return <DatePicker {...props} value={value} onChange={onChange} slotProps={{
    ...slotProps,
    textField: {
      ...slotProps?.textField,
      onBlur: event => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          const normalized = normalizeDialogDate(value);
          if (normalized !== value) onChange?.(normalized);
        }
        slotProps?.textField?.onBlur?.(event);
      },
    },
  }} />;
}
